<script>

	import './style.scss'

	export default {
		name: 'how-it-works',
	}

</script>

<template>
	<div class='how-it-works'>
		<header>
			How It Works
		</header>
		<div class='steps-container'>
			<div class='step'>
				<header>
					<span class='number'>1</span>We Write Problems
				</header>
				<p>
					Get tailored problems from our experts who have interviewed at top companies.
				</p>
			</div>
			<div class='step'>
				<header>
					<span class='number'>2</span>You Solve Them
				</header>
				<p>
					Solve problems every day before you get the solutions the next morning.
				</p>
			</div>
			<div class='step'>
				<header>
					<span class='number'>3</span>We Send The Solution
          <a class="badge">
          <span>PREMIUM</span>
          </a>
				</header>
				<p>
					Verify your work and get better  at problem solving until you land the job!
				</p>
			</div>
		</div>
	</div>
</template>



// WEBPACK FOOTER //
// src/components/HowItWorks/HowItWorks.vue